import { apolloClient } from "@/plugins/vue-apollo.js";

const updateCurrency = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/currency/update_currency.graphql"),
      variables: variables,

      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/currency/get_all_currencies.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        let allCurrency = store.readQuery(query);
        const findIndex = allCurrency.getAllCurrency.currencies.findIndex(
          (item) => item._id === data.updateCurrency._id
        );
        findIndex !== -1 &&
        allCurrency.getAllCurrency.currencies.splice(
            findIndex,
            1,
            data.updateCurrency
          );
        store.writeQuery({
          ...query,
          data: allCurrency,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateCurrency };
